import styled from 'styled-components'
import { mobileL } from '../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const NewApply = styled.div`
  ${mobileL({
    height: '100vh',
  })}

  .new-apply {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    ${mobileL({
      marginTop: '30px',
      height: '100%',
    })}
  }

  .logo {
    ${mobileL({
      position: 'relative',
    })}
  }

  header {
    h1 {
      font-size: 24px;
      font-weight: 600;
      line-height: 40px;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .dropzone {
    border: 1px dashed #80808061;
    padding: 2rem;
    border-radius: 8px;
    cursor: pointer;
    background-color: white;

    p {
      text-align: center;
    }

    span {
      font-size: 14px;
      font-weight: 400;
      margin-top: 15px;
      display: block;
    }
  }

  aside {
    ul {
      display: flex;
      justify-content: space-between;
      list-style: none;
      padding: 0;
      align-items: center;
    }
  }

  .container-sent {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    p {
      max-width: 500px;
      padding: 20px;
      font-size: 18px;
      line-height: 1.75;
      text-align: center;
    }
  }
`
